export class Performance {
  private static records: Record<string, number> = {};

  static start(key = 'default') {
    Performance.records[key] = new Date().getTime();
  }

  static end(key = 'default') {
    const record = Performance.records[key];

    if (record) {
      const endTime = new Date().getTime();
      const elapsedMilliseconds = endTime - record;
      delete Performance.records[key];
      const startText = key === 'default' ? 'Time:' : `${key} took`;
      const message = `${startText} ${elapsedMilliseconds.toLocaleString()} ms`;
      console.debug(message);

      return message;
    } else {
      console.debug(`Key '${key}' not found.`);

      return null;
    }
  }
}
